export default "__VITE_ASSET__a2ac30b7__"